import { JobPanel } from '@/components/JobPanel'
import { SidePanel } from '@/components/SidePanel'
import { useBoardData } from '@/components/useBoardData'
import type { JobInspection } from '@/lib/task-runs'
import { useEffect } from 'react'

export function TaskRunInspector({ experiment, job, attempt, onClose, onBack, onAttempt }: {
  experiment: string; job: string; attempt?: string; onClose: () => void
  onBack?: () => void; onAttempt: (value: string) => void
}) {
  const state = useBoardData<JobInspection>(`/eng/runs/inspect/${encodeURIComponent(experiment)}/${encodeURIComponent(job)}`)
  const live = state.data?.rollout.stage === 'running' || state.data?.rollout.stage === 'queued'
  useEffect(() => {
    if (!live) return
    const timer = window.setInterval(() => { if (!document.hidden) void state.reload() }, 10000)
    return () => clearInterval(timer)
  }, [live, state.reload])
  if (!state.data) return <SidePanel label="rollout" head={<h2>Rollout</h2>} onClose={onClose}>
    {onBack && <button className="btn" onClick={onBack}>← Back</button>}
    <p className={state.error ? 'note err' : 'muted'}>{state.error ?? 'Loading rollout…'}</p>
  </SidePanel>
  return <JobPanel key={`${experiment}/${job}`} runId={experiment} runName={state.data.task.title}
    configuration={state.data.configuration} rollout={state.data.rollout} task={state.data.task}
    taskRollouts={1} rubricMap={state.data.rubric_map} attemptId={attempt} onSelectAttempt={onAttempt}
    onClose={onClose} onBack={onBack} />
}
